import React, {Component} from 'react';
import {Card, CardBody, Col, Row} from 'reactstrap';
import FormSection from './FormSection.js';
import TabNavs from './TabNavs.js';

class ProgramForm extends Component {
	render() {
		let subsectionForm = [];
		let subsectionForm2, subsectionForm3 = false;
		switch (this.props.subsection) {
		case 'MAIN':
			subsectionForm.push(
				<Row key="Prog-Content">
					<Col xs={6} className="squeeze" >
						<FormSection title="" fields={this.props.featureFields} />
					</Col>
					<Col xs={6} className="squeeze" >
						<FormSection title="" fields={this.props.featureFields2} />
					</Col>
				</Row>
			);
			subsectionForm.push(
				<Row key="Prog-Content2" >
					<Col xs={6} className="squeeze">
						<FormSection title="Setup" fields={this.props.setupFields} />
					</Col>
					<Col xs={6} className="setupPad">
						<FormSection title="" fields={this.props.setupFields2} />
					</Col>
				</Row>
			);
			break;
		case 'CONTENT': {
			let contentForm = '';
			switch (this.props.comboFocus) {
			case 'SLIDESHOW':
				contentForm = (
					<div>
						<FormSection 
							title="Logo & Message" 
							fields={this.props.slideshow1Form} 
						/>
						<FormSection
							title="Slideshows"
							fields={this.props.slideshow2Form}
						/>
					</div>
				);
				break;
			case 'INDIVIDUALS':
				contentForm = <FormSection fields={this.props.individualsForm} />;
				break;
			case 'PROPERTY':
				contentForm = <FormSection fields={this.props.propertyFrom} />;
				break;
			case 'AMENITIES':
				contentForm = <FormSection fields={this.props.amenitiesForm} />;
				break;
			case 'SPACE':
				contentForm = <FormSection fields={this.props.spaceForm} />;
				break;
			case 'ANNOUNCEMENTS':
				contentForm = <FormSection fields={this.props.announcementsForm} />;
				break;
			case 'LIST12':
				contentForm = <FormSection fields={this.props.list12Form} />;
				break;
			case 'PDF':
				contentForm = <FormSection fields={this.props.pdfForm} />;
				break;
			case 'COMPANIES':
			default:
				contentForm = <FormSection fields={this.props.companiesForm} />;
				break;
			}

			subsectionForm.push(
				<Row key="Prog-Mods">
					<Col xs={6} className="squeeze">{this.props.contentController}</Col>
					<Col xs={6} className="combo-focused squeeze combo-details">
						<Row>
							<Col />
							<Col xs={10}>{contentForm}</Col>
							<Col />
						</Row>
					</Col>
				</Row>
			);
			break;
		}
		case 'MODIFICATIONS':
		default:
			
			// if (this.props.modFields) {
			// 	Object.keys(this.props.modFields).forEach((fields, i) => {
			// 		subsectionForm.push(
			// 			<Row className="activeRecord ml-0 mr-0" key={`mod-${i}`}>
			// 				<Col xs={12} className="recordHeader">
			// 					<h4>{this.props.modTitles[i]}</h4>
			// 				</Col>
			// 				<Col xs={6} className="recordColumn">
			// 					<FormSection
			// 						fields={this.props.modFields.set1[i]}
			// 					/>
			// 				</Col>
			// 				<Col xs={6} className="recordColumn">
			// 					<FormSection
			// 						fields={this.props.modFields.set2[i]}
			// 					/>
			// 					<FormSection
			// 						fields={this.props.modFields.set3[i]}
			// 					/>
			// 				</Col>
			// 			</Row>
			// 		);
			// 	});
			// }
			
			if (this.props.modElms) {
				subsectionForm.push(this.props.modElms);
			}
			break;
		}

		return (
			<Col sm={this.props.colsize}>
				<br />
				<Card className="standard-form border-0">
					<h2 className="h2 mb-3">{this.props.title}</h2>
					<CardBody>
						<Row>
							<Col xs={4} className="program-login">

								<FormSection title="Status" fields={this.props.statusFields} />
							</Col>
							<Col xs={8} className="program-other">
								<TabNavs
									title={this.props.title}
									section={this.props.section}
									subsection={this.props.subsection}
									changeSubsection={this.props.changeSubsection}
								/>
								{subsectionForm}
							</Col>
						</Row>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default ProgramForm;



// WEBPACK FOOTER //
// ./src/components/ProgramForm.js